var _path, _path2, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99997 3.63638C1.39747 3.63638 0.909058 4.1248 0.909058 4.72729V10.1818C0.909058 10.7843 1.39747 11.2727 1.99997 11.2727H3.27269V9.09089C3.27269 8.4884 3.7611 7.99998 4.3636 7.99998H12.7272C13.3297 7.99998 13.8181 8.4884 13.8181 9.09089V11.2727H14.9091C15.5116 11.2727 16 10.7843 16 10.1818V4.72729C16 4.1248 15.5116 3.63638 14.9091 3.63638H1.99997Z",
    fill: "#0A46F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 9C3.7 8.83431 3.83431 8.7 4 8.7H13C13.1657 8.7 13.3 8.83431 13.3 9V14C13.3 14.718 12.718 15.3 12 15.3H5C4.28203 15.3 3.7 14.718 3.7 14V9Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 10.9,
    width: 5.2,
    height: 0.9,
    rx: 0.45,
    fill: "#0A46F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.9,
    y: 12.7181,
    width: 5.2,
    height: 0.9,
    rx: 0.45,
    fill: "#0A46F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.7,
    y: 0.7,
    width: 8.78182,
    height: 6.6,
    rx: 1.3,
    stroke: "#0A46F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/Print.16358a0b.svg";
export { ForwardRef as ReactComponent };